import React, { useEffect, useState } from "react";
import Header from "../../Components/Header/Header";
import Footer from "../../Components/Footer/Footer";
import WalletComponent from "../../Components/WalletComponent/WalletComponent";
import { Apiurl, GetLocalStorageParsed, parseData, stringifyData } from "../utils/page";
import axios from "axios";
import { toast } from "react-toastify";


const Wallet = () => {
  const FetchToken = GetLocalStorageParsed("AuthToken");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);



  const [loginToken, setLoginToken] = useState(FetchToken || null);
  const [ReferralData, setReferralData] = useState("");
  const [addPointModal, setAddPointModal] = useState(false);

  const [showAlert, setShowAlert] = useState(true);
  const [analyticData, setAnalyticData] = useState();
  const [pointSummaryData, setPointSummaryData] = useState();
  const [filterData, setFilteredData] = useState();
  const [show, setShow] = useState(false);
  const [selectedSlab, setSelectedSlab] = useState();
  const [getProfileData, setGetProfielData] = useState();
  const [afterPaymentPointUpdate, setAfterPaymentPointUpdate] = useState(false)
  const [profileImage, setProfileImage] = useState()


  const [pointSLabData, setPointSlabData] = useState();


  const handleCloseAddPointModal = () => {
    setAddPointModal(false)
    setSelectedSlab();
  }


  const getUserInfoo = () => {
    const option = {
      method: "GET",
      headers: {
        accept: "*/*",
        Authorization: `Bearer ${loginToken || " "}`,
      },
      url: `${Apiurl()}/api/Customer/UserInfo`,
    };
    axios(option)
      .then((e) => {
        const data=parseData(e?.data?.result);
        setReferralData(parseData(e?.data?.result));
        const imagePath = data?.Image?.replace(/^\"|\"$/g, ""); // Remove surrounding quotes
        setProfileImage(`${Apiurl()}/${imagePath}`,'imagePath')
      })
      .catch((error) => { });
  };
  const GetPointAnalytic = () => {
    const option = {
      method: "GET",
      headers: {
        accept: "*/*",
        Authorization: `Bearer ${loginToken || " "}`,
      },
      url: `${Apiurl()}/api/Customer/UserPointsAnalytics`,
    };
    axios(option)
      .then((e) => {
        setAnalyticData(parseData(e?.data?.result));
      })
      .catch((error) => { });
  };


  const handleCopyUrl = () => {
    const baseUrl = `${window.location.protocol}//${window.location.host}`;


    const urlWithReferral = `${baseUrl}/referralcode/${ReferralData.ReferralCode}`;

    navigator.clipboard.writeText(urlWithReferral)
    setTimeout(() => {
      setShowAlert(false);
    }, 1000);
    setTimeout(() => {
      setShowAlert(true);
    }, 3000);
  };

  const handleShow = () => {
    setShow(true);
  }
  const handleClose = () => {
    setShow(false);

  }

  const handlePointSummary = () => {

    const data = {}

    const option = {
      method: "POST",
      headers: {

        'Content-Type': 'application/json',
        'Authorization': `Bearer ${loginToken}`
      },
      data: stringifyData(data),

      url: `${Apiurl()}/api/Customer/PointSummary`,
    };
    axios(option)
      .then((e) => {
        setPointSummaryData(parseData(e?.data?.result));
        setFilteredData(parseData(e?.data?.result));
      })
      .catch((error) => {
      });

  }
  const getPointSlab = () => {
    const option = {
      method: "POST",
      headers: {
        accept: "*/*",
        Authorization: `Bearer ${loginToken || " "}`,
      },
      url: `${Apiurl()}/api/Admin/GetAllMoneyToPointsSlabs`,
    };
    axios(option)
      .then((e) => {
        const data = parseData(e?.data?.result);
        setPointSlabData(data)

      })
      .catch((error) => { });
  };

  useEffect(() => {
    if (loginToken) {
      getUserInfoo();
      GetPointAnalytic();
      handlePointSummary();
      getPointSlab()

    }

  }, [loginToken]);

  const handleSelectPoint = (e) => {
    setSelectedSlab(e)

  }
  const handlePay = async (e) => {
    // return
    const options = {
      key: "rzp_live_SEIuC9F9Y9pG1r", //live
      // key: 'rzp_test_0F6zCrTs97XdnP',//test
      amount: stringifyData(selectedSlab?.Money * 100),
      currency: "INR",
      name: "Shop Saverz",
      description: "Payment for Order or money for wallet",
      // order_id: orderId,
      prefill: {
        name: getProfileData?.Name,
        email: getProfileData?.Email,
        contact: getProfileData?.PhoneNumber,
      },
      handler: async (response) => {
        handleAfterPayment(response?.razorpay_payment_id)
      },
    };
    const paymentObject = new window.Razorpay(options);
    paymentObject.open();


  }
  const handleAfterPayment = (transId) => {
    const data = {
      transactionId: transId,
      slabId: selectedSlab?.Id
    }

    const option = {
      method: "POST",
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${loginToken}`
      },
      data: stringifyData(data),
      url: `${Apiurl()}/api/Vendor/MoneyToPointsTransaction`,
    };
    axios(option)
      .then((e) => {
        setAfterPaymentPointUpdate(true);
        getUserInfoo();
        GetPointAnalytic();
        setAddPointModal(false);
        setSelectedSlab();
        if (e?.data?.status === "OK") {
                  toast.success(e?.data?.message);
                }
                if (e?.data?.status === "BadRequest") {
                  toast.error(e?.data?.message);
                }

        // router(`/paymentsuccess/${finalValue}=${transId}`)
        // setLoadingFull(false);

      })
      .catch((error) => {
        // router(`/paymentfailed/${finalValue}=${transId}`)
        // setLoadingFull(false);


      });
  }

  return (
    <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>

      <Header setLoginToken={setLoginToken} setGetProfielData={setGetProfielData} setAfterPaymentPointUpdate={setAfterPaymentPointUpdate} afterPaymentPointUpdate={afterPaymentPointUpdate} />
      <WalletComponent ReferralData={ReferralData} handleCopyUrl={handleCopyUrl} showAlert={showAlert} handleShow={handleShow} show={show} handleClose={handleClose}
        analyticData={analyticData} pointSummaryData={pointSummaryData} setPointSummaryData={setPointSummaryData}
        setFilteredData={setFilteredData} filterData={filterData} setAddPointModal={setAddPointModal} addPointModal={addPointModal}
        handleCloseAddPointModal={handleCloseAddPointModal} pointSLabData={pointSLabData} handleSelectPoint={handleSelectPoint}
        selectedSlab={selectedSlab} setSelectedSlab={setSelectedSlab} handlePay={handlePay} getProfileData={getProfileData} profileImage={profileImage}

      />
      <Footer />
    </div>
  );
};

export default Wallet;